import styled from '@emotion/styled'

const IconButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;

  svg {
    height: 100%;
  }
`

export default IconButton
